import { Image } from "antd";
import fallbackImage from "~/assets/images/no-picture.png";
import MDBox from "~/components/MDBox";
import MDTypography from "~/components/MDTypography";
// eslint-disable-next-line react/prop-types
const AuthorAvatar = ({ image, name, email, icon }) => (
  <MDBox display="flex" alignItems="center" lineHeight={1}>
    <Image
      src={image}
      width={50}
      height={50}
      fallback={fallbackImage}
      preview={image === null ? false : true}
      // name={name}
      // size="sm"
      // icon={icon}
    />
    <MDBox ml={2} lineHeight={1}>
      <MDTypography display="block" variant="button" fontWeight="medium">
        {name}
      </MDTypography>
      {/* <MDTypography variant="caption">{email}</MDTypography> */}
    </MDBox>
  </MDBox>
);
export default AuthorAvatar;
